import { Component, OnInit, HostListener, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CUtilit } from '../../classes/utilit';
import { Router } from '@angular/router';
import { DataSnapResult, LoggedUserData } from '../../classes/json-interface';
import { AppToolbarService } from '../../components/toolbar/services/app-toolbar.service';
import { CST_EMPTY_DISPOTITION } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { MatDialog } from '@angular/material/dialog';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { InitApp } from 'src/app/classes/init-all';
import { LoggedUserService } from 'src/app/services/loged-user/loged-user.service';
import { g_params } from 'src/app/classes/global-param';
import { Subject } from 'rxjs';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {

  @ViewChild('inputLogin', {static: true}) mInputLogin!: ElementRef<HTMLInputElement>;
  @ViewChild('inputPassword', {static: true}) mInputPassword!: ElementRef<HTMLInputElement>;

  public HTML_Username = '';
  public HTML_Password = '';
  public HTML_Password_hide = true;

  public HTML_FactoryName = '';
  public HTML_AdressFactoryLogo?: SafeUrl | string | ArrayBuffer | null;

  public HTML_Result: string = '';

  public mLockInProgress: boolean;  // True = on lock les btn + spinner

  // Un example de code pour le drag and drop a laisser pour tester l'import deco par la suite
  //Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    console.log('loggin dragover');
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    console.log('loggin dragleave');
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    const files: FileList = evt.dataTransfer.files;
    if (files.length > 0) {
      const reader = new FileReader();
      const subjectDataFile = new Subject<any>();
      subjectDataFile.subscribe(
        next => {
          this.HTML_AdressFactoryLogo = next;
        }
      );
      reader.onload = ev => {
        if (!ev)
          return;
        if (ev.target == null)
          return;
        console.log('e  ', ev);
        console.log('e.targer.result ', ev.target.result);
        this.HTML_AdressFactoryLogo = ev.target.result;
        subjectDataFile.next(ev.target.result);
      };

      // @ts-ignore TODO: TS2345: Argument of type 'File | null' is not assignable to parameter of type 'Blob'.   Type 'null' is not assignable to type 'Blob'.
      reader.readAsDataURL(files.item(0));
      console.log('file receive', files);

    }
  }

  constructor(private mHttp: HttpClient,
              private mSanitizer: DomSanitizer,
              private router: Router,
              private mDialog: MatDialog,
              private toolbarService: AppToolbarService,
              private mLoggeduser: LoggedUserService,
              private mArmaServServerMethods: ArmaServServerMethods) {
    this.HTML_AdressFactoryLogo = '';
    this.mLockInProgress = false;
  }

  ngOnInit() {
    this.toolbarService.setDisposition(CST_EMPTY_DISPOTITION);
    this.toolbarService.setVisibility(false);
    // Recuperation du nom de l'usine
    this.HTML_FactoryName = g_params.g_factoryName;
    ArmaServConnection.isConnected(this.mHttp).then(result => {
      if (result) this.router.navigateByUrl('/home');
    });
    this.mDialog.closeAll();
  }

  ngAfterViewInit() {
    this.loadAsyncFactoryLogo();
    setTimeout(() => this.focusLogin());
  }

  /**
   * Recuperation du logo de l'usine
   */
  async loadAsyncFactoryLogo() {
    this.HTML_AdressFactoryLogo = await ArmaServConnection.getSafeUrlImgFromDatasnap(this.mHttp, this.mSanitizer, 'GetFactoryLogo', []);
  }

  public focusLogin() {
    if (!this.mInputLogin)
      return;
    this.mInputLogin.nativeElement.focus();
    this.mInputLogin.nativeElement.select();
  }

  public focusPassword() {
    if (!this.mInputPassword)
      return;
    this.mInputPassword.nativeElement.focus();
    this.mInputPassword.nativeElement.select();
  }

  /**
   * Procedure de connection au site web
   */
  public async connect() {
    this.mLockInProgress = true;
    try {
      // On tente de se connecter avec les infos de connexion données
      const resultLoggin = await this.mArmaServServerMethods.updateLogin({
        user: this.HTML_Username,
        password: /*CUtilit.hashMD5(*/this.HTML_Password/*)*/ // TODO : Crypter le mot de passe pour les connexion. Code pret sur angular mais de grosse modif sont a prévoir niveau armaor
      });
      // On verifier que l'on a bien reussi a se conencter
      if (resultLoggin.Connected) {
        //await this.mLoggeduser.loadFromServer();    // On chage les info de connection dans le service dédié
        this.mLoggeduser.setLoggedUser(resultLoggin.RightUser);
        const arraySite = await InitApp.refreshArraySite(this.mArmaServServerMethods); // Une fois connecter on doit recupere la liste des chantier disponible pour la connection
        // reset du code chantier
        if (arraySite.length > 0)
          this.mLoggeduser.setSiteCode(arraySite[0]);
        CUtilit.setUserName(this.HTML_Username);    // ?
        //CUtilit.setSelectedSiteCode(CST_ALL_SITE_SELECTOR.IDCHANTIER);
        this.toolbarService.refreshToolbar(true);   // On refresh les infos de la toolbar
        this.router.navigateByUrl('/home');         // On passe sur la page principale
      } else if (resultLoggin.AlreadyLogged) {
          // Si on a pas reussi a se connecter
          // On verifie si qqun est déja connecté avec nos info de connection
          this.HTML_Result = 'This user is already connected with another computer !, Disconect the other computer first';
      } else {
          this.HTML_Result = 'Login failed';
          this.focusLogin();
      }
    } catch (e) { // En cas de soucis lors de l'exec de la requette
      console.error(e);
      this.HTML_Result = 'Unnable to reach the server';
    } finally {
      this.mLockInProgress = false;
    }
  }

  public shape() {
    this.router.navigateByUrl('/shapes');
  }
}
